import { render, staticRenderFns } from "./error404.vue?vue&type=template&id=6ecfd4ac&scoped=true&"
var script = {}
import style0 from "./error404.vue?vue&type=style&index=0&id=6ecfd4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecfd4ac",
  null
  
)

export default component.exports